import React from "react";
import { Link } from "react-router-dom";
import { MUSICADE_EVENT_URL } from "../constants/apiUrls";

const Navbar: React.FC = () => (
  <nav className="bg-gradient-to-r from-indigo-500 to-purple-600 shadow-md">
    <div className="container mx-auto px-4 py-3 flex items-center justify-between">
      <Link to="/" className="flex items-center">
        <img src="/assets/LOGO.png" alt="Musicade logo" className="h-8 w-auto" />
      </Link>
      <button className="md:hidden text-white">
        <span className="material-icons">menu</span>
      </button>
      <div className="hidden md:flex items-center space-x-6">
        <a href={MUSICADE_EVENT_URL} target="_blank" rel="noopener noreferrer" className="text-white hover:text-indigo-200 font-medium">Find Events</a>
        <Link to="/" className="text-white hover:text-indigo-200 font-medium">Home</Link>
        <Link to="/terms" className="text-white hover:text-indigo-200 font-medium">Terms of Service</Link>
        <Link to="/privacy-policy" className="text-white hover:text-indigo-200 font-medium">Privacy Policy</Link>
        <button className="bg-purple-900 bg-opacity-80 hover:bg-opacity-100 text-white px-5 py-2 rounded-full flex items-center space-x-2 border border-purple-800 transition-all">
          <span>Download</span>
          <span className="material-icons text-sm">download</span>
        </button>
      </div>
    </div>
  </nav>
);

export default Navbar;
